var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal baggage-modal",
      class: { "modal--visible": _vm.visible }
    },
    [
      _c("div", {
        staticClass: "modal__overlay",
        on: {
          click: function($event) {
            return _vm.$emit("close")
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal__content baggage-modal__content",
          attrs: {
            role: "dialog",
            "aria-modal": "true",
            "aria-label": _vm.title
          }
        },
        [
          _c(
            "button",
            {
              staticClass: "modal__close",
              attrs: { type: "button", "aria-label": "Close" },
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            },
            [_vm._v("×")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "baggage-modal__intro" }, [
            _c("h3", { staticClass: "baggage-modal__title" }, [
              _vm._v(_vm._s(_vm.title))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "baggage-modal__subtitle" }, [
              _vm._v(
                _vm._s(
                  _vm._f("locale")(
                    "Det är ofta billigare att lägga till bagage nu än på flygplatsen."
                  )
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "baggage-modal__scroll" }, [
            _c(
              "div",
              { staticClass: "baggage-modal__panel" },
              [
                _c("div", { staticClass: "baggage-modal__panel-head" }, [
                  _vm.cabinBagIncluded
                    ? _c("span", {
                        staticClass:
                          "baggage-modal__panel-icon fa fa-briefcase",
                        attrs: { "aria-hidden": "true" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", [
                    _vm.cabinBagIncluded
                      ? _c(
                          "div",
                          { staticClass: "baggage-modal__panel-title" },
                          [_vm._v(_vm._s(_vm._f("locale")("Handbagage ingår")))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "baggage-modal__panel-sub" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("locale")(
                            "Du kan ändra per resenär senare på sidan."
                          )
                        )
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm._l(_vm.passengers, function(passenger) {
                  return _c(
                    "div",
                    {
                      key: passenger.number,
                      staticClass: "baggage-modal__pax"
                    },
                    [
                      _c("div", { staticClass: "baggage-modal__pax-title" }, [
                        _vm._v(_vm._s(passenger.title))
                      ]),
                      _vm._v(" "),
                      _vm._l(passenger.options, function(option) {
                        return _c(
                          "label",
                          {
                            key: option.id,
                            staticClass: "baggage-modal__option",
                            class: {
                              "baggage-modal__option--checked":
                                _vm.chosen[option.id],
                              "baggage-modal__option--selected":
                                option.selectedAll
                            }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.chosen[option.id],
                                  expression: "chosen[option.id]"
                                }
                              ],
                              staticClass: "baggage-modal__checkbox",
                              attrs: {
                                type: "checkbox",
                                disabled: option.selectedAll
                              },
                              domProps: {
                                checked: Array.isArray(_vm.chosen[option.id])
                                  ? _vm._i(_vm.chosen[option.id], null) > -1
                                  : _vm.chosen[option.id]
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.chosen[option.id],
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.chosen,
                                          option.id,
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.chosen,
                                          option.id,
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.chosen, option.id, $$c)
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "baggage-modal__option-icon fa",
                              class: option.icon,
                              attrs: { "aria-hidden": "true" }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "baggage-modal__option-text" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "baggage-modal__option-title"
                                  },
                                  [_vm._v(_vm._s(option.title))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "baggage-modal__option-price"
                                  },
                                  [_vm._v(_vm._s(option.priceText))]
                                ),
                                _vm._v(" "),
                                option.partial
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "baggage-modal__option-note"
                                      },
                                      [_vm._v(_vm._s(_vm.partialNote))]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                })
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "baggage-modal__footer" }, [
            _c("div", { staticClass: "baggage-modal__actions" }, [
              _c(
                "button",
                {
                  staticClass: "baggage-modal__btn baggage-modal__btn--ghost",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("continue")
                    }
                  }
                },
                [
                  _vm._v(
                    "\n          " + _vm._s(_vm.continueText) + "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "baggage-modal__btn baggage-modal__btn--primary",
                  attrs: { type: "button", disabled: !_vm.hasSelection },
                  on: { click: _vm.apply }
                },
                [_vm._v("\n          " + _vm._s(_vm.addText) + "\n        ")]
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }